import { Component, OnInit, inject, input, signal } from '@angular/core';
import { faUpload } from '@fortawesome/pro-solid-svg-icons';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { FileInfo, UploadEvent } from '@progress/kendo-angular-upload';
import { FileModel } from '../../../../core/models/file/file.model';
import { FileService } from '../../../../core/services/file.service';
import { FileEntityKey, FileEntityKind } from '../../../data-types/file-types';
import { HttpParamObject } from '../../../data-types/http-types';
import { assert } from '../../../../core/assert/assert';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrl: './file-upload-dialog.component.scss',
  standalone: false,
})
export class FileUploadDialogComponent implements OnInit {
  readonly fileEntityKind = input.required<FileEntityKind>();
  readonly fileEntityKey = input.required<FileEntityKey>();
  readonly fileEntityValue = input.required<number>();
  readonly dropZoneId = signal('upload-dialog-dropzone');
  readonly progress = signal(0);

  /** Optional: restrict file types / size */
  public readonly restrictions = {
    allowedExtensions: ['.pdf', '.png', '.jpg', '.jpeg', '.docx'],
    maxFileSize: 20 * 1024 * 1024, // 20 MB
  };
  public readonly faUpload = faUpload;

  public files: FileInfo[] = [];

  // DI
  private readonly ref = inject(DialogRef);
  private readonly fileService = inject(FileService);

  ngOnInit(): void {
    this.fileService.progress$.subscribe((progress) => this.progress.set(progress));
  }

  onUpload(e: UploadEvent) {
    e.preventDefault();

    assert(!!this.fileEntityKind() && !!this.fileEntityKey());

    const fileModel = new FileModel();
    fileModel.file = e.files[0].rawFile;
    const params: HttpParamObject = {
      kind: this.fileEntityKind(),
      [this.fileEntityKey()]: this.fileEntityValue(),
    };
    this.fileService.uploadFile(fileModel, params);
  }

  close() {
    this.ref.close();
  }
}
